// Each new section item as it was created, serialised. A new item has no saved original, so
// this is what "unchanged" means for it. Module state shared by every native view; lost on
// reload, where the item then counts as changed.
const seeds = new Map<string, string>();

/**
 * value without the placeholders edit fields write on mount: objects holding nothing but an
 * `_id`, such as the group GroupField creates, and empty lists.
 */
const withoutPlaceholders = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(withoutPlaceholders);
  if (!value || typeof value !== "object") return value;
  const result: Record<string, unknown> = {};
  for (const [key, entry] of Object.entries(value)) {
    const stripped = withoutPlaceholders(entry);
    if (Array.isArray(stripped) && stripped.length === 0) continue;
    if (stripped && typeof stripped === "object" && Object.keys(stripped).every((k) => k === "_id")) continue;
    result[key] = stripped;
  }
  return result;
};

const serialise = (item: unknown) => JSON.stringify(withoutPlaceholders(item));

/** Records item as the unchanged state of the new item with its id. */
export const recordNewItemSeed = (item: { _id: string }) => {
  seeds.set(item._id, serialise(item));
};

/** Whether item differs from the seed recorded for the new item id; true for an item with no seed. */
export const differsFromNewItemSeed = (id: string, item: unknown) => {
  const seed = seeds.get(id);
  if (seed === undefined) return item !== undefined;
  return serialise(item) !== seed;
};
